import { useState } from "react"

// images
import todoImage from "@/assets/img/icons/todo.svg"
import completeImage from "@/assets/img/icons/complete.svg"
import menuImage from "@/assets/img/icons/table-menu.png"
import editImage from "@/assets/img/icons/edit.svg"
import deleteImage from "@/assets/img/icons/delete.svg"
import previewImage from "@/assets/img/todo/icons/preview.svg"
import pauseImage from "@/assets/img/todo/icons/pause.svg"
import flagImage from "@/assets/img/icons/flag.svg"

// providers
import { trans } from "@/_providers/Translation"

// libraries
import { Menu } from "@mui/material"
import SnoozeUpcomingTodoButton from "./SnoozeUpcomingTodoButton"

export default function SingleUpcomingTodo({
  todo,
  onEdit,
  onDelete,
  onComplete,
  onTogglePause,
  onView,
  onStopRepeat,
  onToggleFlag,
}) {
  const [openMenu, setOpenMenu] = useState(null)

  const handleTableMenu = (e) => {
    setOpenMenu(e.currentTarget)
  }

  const handleCloseMenu = () => {
    setOpenMenu(null)
  }

  const handleEdit = () => {
    handleCloseMenu()

    onEdit(todo.id)
  }

  const handleDelete = () => {
    handleCloseMenu()

    onDelete(todo.id)
  }

  const handleComplete = () => {
    handleCloseMenu()

    onComplete(todo.id)
  }

  const handleTogglePause = () => {
    handleCloseMenu()

    onTogglePause(todo.id)
  }

  const handleView = () => {
    handleCloseMenu()

    onView(todo)
  }

  const handleStopRepeat = () => {
    handleCloseMenu()

    onStopRepeat(todo.id)
  }

  const handleFlag = () => {
    handleCloseMenu()
    onToggleFlag(todo.id)
  }

  return (
    <li>
      <span className="icon">
        <img src={todoImage} alt="todo" />
      </span>
      <div className="info">
        <b>{trans("buttons.newTodo")}</b>
        <h3>{todo.title}</h3>
      </div>
      <div className="options">
        <SnoozeUpcomingTodoButton id={todo.id} />
        {!todo.completed_at && todo.can_mark_as_completed && (
          <button className="button-add button-small" onClick={handleComplete}>
            <img src={completeImage} alt="complete" />
            {trans("buttons.complete")}
          </button>
        )}
        <img
          src={menuImage}
          alt="menu"
          className="menu"
          onClick={handleTableMenu}
          style={{
            display: "block",
            width: "15px",
            height: "19px",
            objectFit: "contain",
            cursor: "pointer",
          }}
        />
        <Menu
          id={"menu-" + todo.id}
          anchorEl={openMenu}
          keepMounted
          open={Boolean(openMenu)}
          onClose={handleCloseMenu}
        >
          <div className="menu-option" onClick={handleView}>
            <img src={previewImage} alt="group mail" />
            {trans("buttons.view")}
          </div>

          {todo.can_mark_as_completed && (
            <div className="menu-option" onClick={handleTogglePause}>
              <img src={pauseImage} alt="group mail" />
              {todo.paused_at
                ? trans("buttons.removePause")
                : trans("buttons.pause")}
            </div>
          )}

          {Number(todo?.repeat) === 1 ||
          (todo?.parent && Number(todo?.parent?.repeat) === 1) ? (
            <div className="menu-option" onClick={handleStopRepeat}>
              <img src={editImage} alt="edit" />
              {trans("buttons.noRepeat")}
            </div>
          ) : (
            ""
          )}

          <div className="menu-option" onClick={handleEdit}>
            <img src={editImage} alt="edit" />
            {trans("buttons.edit")}
          </div>
          <div className="menu-option" onClick={handleFlag}>
            <img src={flagImage} alt="flag" />
            {todo.flagged ? trans("buttons.removeFlag") : trans("buttons.flag")}
          </div>
          {todo.isOwner ? (
            <div
              className="menu-option"
              onClick={handleDelete}
              style={{
                color: "#EC5252",
              }}
            >
              <img src={deleteImage} alt="delete" />
              {trans("buttons.delete")}
            </div>
          ) : (
            <></>
          )}
        </Menu>
      </div>
    </li>
  )
}
